<template>    
    <div class="content min-vh-100 flex-column d-flex justify-content-between" v-if="profile">
        <UserPreview editable />
        <section>
            <form>
                <div class="row">
                    <!-- <div class="col-12 col-md-6">
                        <b-form-group label="Policy number" label-for="ins_pol_number" label-class="font-italic">
                            <b-form-input v-model="policyNumber" id="ins_pol_number" class="form-control-lg" disabled></b-form-input>
                        </b-form-group>
                    </div> -->
                    <div class="col-12 col-md-6">
                        <b-form-group label="Policy effect date" label-for="ins_pol_effect_date" label-class="font-italic">
                            <b-form-input v-model="profile.effect_date" id="ins_pol_effect_date" class="form-control-lg" disabled></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-12 col-md-6">
                        <b-form-group label="Policy expiry date" label-for="ins_pol_expire_date" label-class="font-italic">
                            <b-form-input v-model="profile.expire_date" id="ins_pol_expire_date" class="form-control-lg" disabled></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-12 col-md-6">
                        <b-form-group label="Name" label-for="full_name" label-class="font-italic">
                            <b-form-input v-model="profile.name" id="full_name" class="form-control-lg" disabled></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-12 col-md-6">
                        <b-form-group label="Date of birth" label-for="date_of_birth" label-class="font-italic">
                            <b-form-input v-model="dob" class="form-control-lg" disabled></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-12 col-md-6">
                        <b-form-group label="Nationality" label-for="country" label-class="font-italic">
                            <b-form-input v-model="country" id="country" class="form-control-lg" disabled></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-12 col-md-6">
                        <b-form-group label="Email" label-for="email" label-class="font-italic">
                            <b-form-input v-model="profile.email" id="email" class="form-control-lg" disabled></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-12 col-md-6">
                        <b-form-group label="Mobile" label-for="phone_number" label-class="font-italic">
                            <b-form-input v-model="profile.phoneNumber" id="phone_number" class="form-control-lg" disabled></b-form-input>
                        </b-form-group>
                    </div>
                </div>
                <hr />
                <div class="row profile-set">
                    <div class="col-12 d-flex">
                        <div class="flex-grow-1">
                            CHANGE PASSWORD
                        </div>
                        <div class="d-flex align-items-center">
                            <button type="button" class="btn btn-link" v-b-modal.modal-change-password>
                                <img src="img/ico-edit.svg" alt="Edit" />
                            </button>
                        </div>
                        <ModalChangePassword id="modal-change-password"/>
                    </div>
                    <div class="col-12 d-flex">
                        <div class="flex-grow-1">
                            PRIVACY SETTINGS
                        </div>
                        <div class="d-flex align-items-center">
                            <router-link :to="{ name: 'PrivacySettings' }">
                                <img src="img/ico-edit.svg" alt="Edit" />
                            </router-link>
                        </div>
                    </div>
                </div>
            </form>
        </section>
    </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import api from '../http/api.js';
//import EditableInput from '@/components/EditableInput.vue'
import UserPreview from '@/components/UserPreview.vue'
import ModalChangePassword from '@/components/modals/ChangePassword.vue'

import { mapFields } from 'vuex-map-fields';


export default {
  name: 'Profile',
  components: {
    //EditableInput,
    UserPreview,
    ModalChangePassword,
    //ModalChangePrivacy
  },
  data: function () {
    return {
        dob: null,
        country: null,
    }
  },
  computed: {
        /*
        policyNumber(){
            //console.log("computed", this.$store.state.policyNumber);
            //return this.$store.state.userInfo.policyNumber;
            return "123213123"
        },
        */
        ...mapFields({
            profile: 'userInfo',
        }),
    },
  
  /*watch: {
        profile: function(){
            //console.log("watch fullName");
            this.fullName =  this.profile.first_name + " " + this.profile.second_name;
        },
        //'$route': 'fetchData'
  }, */
  created () {
    // fetch the data when the view is created and the data is
    // already being observed
    //console.log("created");
    this.fetchData();
  },
  methods: {
    fetchData () {
        //console.log("fetchData");
        this.error = this.profile = null

        api.get('/v1/me')
            .then((response) => {
                console.log(response);
                this.$store.commit('user_info', response.data.data)
                this.dob = response.data.data.infos.date_of_birth
                this.country = response.data.data.infos.country
                
            }, () => {
                //console.log(error);
            });
    }, 
    update () {
        api.post('/v1/me', this.profile);
    }
  }
}
</script>